"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeeksForMonth = exports.DATE_PICKER_ERROR_MESSAGES = exports.getValidationErrorMessage = exports.DECIMAL_RADIX = exports.INPUT_VALIDATION_ERROR_MESSAGES = exports.DATE_PICKER_ARIA_LABELS = exports.SAFE_TIMEZONE_REMOVAL_PATTERN = exports.TIMEZONE_PATTERN = exports.TIME_MENU_CONSTANTS = exports.DEFAULT_INTERVAL_MINUTES = exports.FORM_CONTROL_UPDATE_ON = exports.COMPONENT_SIZES = exports.TIME_FORMAT_CONSTANTS = exports.MONTH_INDEX_OFFSET = exports.DAYS_IN_WEEK = exports.MIN_HOUR_24H_FORMAT = exports.MIN_HOUR_12H_FORMAT = exports.DEFAULT_TIME_ZONE = exports.MIN_TIME_VALUE = exports.MAX_MINUTES = exports.MAX_HOUR_24H_FORMAT = exports.MAX_HOUR_12H_FORMAT = exports.TIME_COMBINED_FORMAT_PATTERN = exports.TIME_12H_FORMAT_PATTERN = exports.TIME_24H_FORMAT_PATTERN = exports.TIME_OUTPUT_PATTERN = exports.TIME_FORMAT_PATTERN = exports.DATE_FORMAT_PATTERN = void 0;
/**
 * Date and time validation patterns
 */
exports.DATE_FORMAT_PATTERN = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
exports.TIME_FORMAT_PATTERN = /^(\d{1,2})[:.]\s*(\d{2})\s*(AM|PM)(\s+[A-Z]{2,4})?$/i;
exports.TIME_OUTPUT_PATTERN = /^(\d{1,2}):(\d{2})\s*(AM|PM)(\s+[A-Z]{2,4})?$/i;
// 24 hours pattern and combined patterns (12h and 24h with optional timezone)
exports.TIME_24H_FORMAT_PATTERN = /^([01]?\d|2[0-3]):([0-5]\d)(\s+[A-Z]{2,4})?$/i;
exports.TIME_12H_FORMAT_PATTERN = /^(1[0-2]|0?[1-9]):([0-5]\d)\s*(AM|PM)(\s+[A-Z]{2,4})?$/i;
exports.TIME_COMBINED_FORMAT_PATTERN = /^([01]?\d|2[0-3]|1[0-2]):([0-5]\d)(\s*(AM|PM))?$/i;
/**
 * Time validation constants
 */
exports.MAX_HOUR_12H_FORMAT = 12;
exports.MAX_HOUR_24H_FORMAT = 23;
exports.MAX_MINUTES = 59;
exports.MIN_TIME_VALUE = 0;
exports.DEFAULT_TIME_ZONE = 'EST';
// Validation regex constants
exports.MIN_HOUR_12H_FORMAT = 1;
exports.MIN_HOUR_24H_FORMAT = 0;
exports.DAYS_IN_WEEK = 7;
exports.MONTH_INDEX_OFFSET = 1;
/**
 * Time formatting constants to avoid magic numbers
 */
exports.TIME_FORMAT_CONSTANTS = {
  PAD_LENGTH: 2,
  PAD_CHARACTER: '0',
  DECIMAL_BASE: 10,
  MINUTES_IN_HOUR: 60,
  MINUTES_IN_DAY: 24 * 60
};
/**
 * Component size constants to avoid magic strings
 */
exports.COMPONENT_SIZES = {
  MEDIUM: 'medium',
  SMALL: 'small'
};
/**
 * Form control constants to avoid magic strings
 */
exports.FORM_CONTROL_UPDATE_ON = {
  BLUR: 'blur',
  CHANGE: 'change',
  SUBMIT: 'submit'
};
/**
 * Default values to avoid magic numbers
 */
exports.DEFAULT_INTERVAL_MINUTES = 15;
/**
 * Time menu constants to avoid magic numbers
 */
exports.TIME_MENU_CONSTANTS = {
  MINUTES_IN_HOUR: 60,
  MINUTES_IN_DAY: 24 * 60,
  PAD_LENGTH: 2,
  PAD_CHARACTER: '0'
};
/**
 * Timezone pattern constants - Security hardened against ReDoS
 * Using single space instead of \s+ to prevent backtracking
 */
exports.TIMEZONE_PATTERN = /\s[A-Z]{2,4}$/i;
exports.SAFE_TIMEZONE_REMOVAL_PATTERN = /\s[A-Z]{2,4}$/i;
/**
 * Accessibility text constants
 */
exports.DATE_PICKER_ARIA_LABELS = {
  DATE: 'Open date menu',
  TIME: 'Open time menu'
};
/**
 * Input validation error messages structure
 */
exports.INPUT_VALIDATION_ERROR_MESSAGES = {
  date: {
    pattern: 'Please enter a valid date format (MM/DD/YYYY)',
    invalidValue: 'This date is not allowed'
  },
  time: {
    pattern: {
      format12h: 'Please enter a valid time format (H:MM AM/PM)',
      format24h: 'Please enter a valid time format (HH:MM)',
      general: 'Please enter a valid time format'
    },
    invalidValue: 'This time is not allowed'
  }
};
// Decimal radix constant
exports.DECIMAL_RADIX = 10;
/**
 * Enhanced validation error message functions
 */
exports.getValidationErrorMessage = {
  /**
   * Get pattern error message for date input
   */
  datePattern: () => exports.INPUT_VALIDATION_ERROR_MESSAGES.date.pattern,
  /**
   * Get invalid date error message
   */
  dateInvalid: () => exports.INPUT_VALIDATION_ERROR_MESSAGES.date.invalidValue,
  /**
   * Get pattern error message for time input based on format
   * @param use24HourFormat - Whether to use 24-hour format
   */
  timePattern: use24HourFormat => {
    if (use24HourFormat === true) {
      return exports.INPUT_VALIDATION_ERROR_MESSAGES.time.pattern.format24h;
    } else if (use24HourFormat === false) {
      return exports.INPUT_VALIDATION_ERROR_MESSAGES.time.pattern.format12h;
    }
    return exports.INPUT_VALIDATION_ERROR_MESSAGES.time.pattern.general;
  },
  /**
   * Get invalid time error message
   */
  timeInvalid: () => exports.INPUT_VALIDATION_ERROR_MESSAGES.time.invalidValue,
  /**
   * Get pattern error message based on input type and format
   * @param type - Input type ('date' or 'time')
   * @param use24HourFormat - Whether to use 24-hour format (only for time)
   */
  pattern: (type, use24HourFormat) => {
    return type === 'date' ? exports.getValidationErrorMessage.datePattern() : exports.getValidationErrorMessage.timePattern(use24HourFormat);
  },
  /**
   * Get invalid value error message based on input type
   * @param type - Input type ('date' or 'time')
   */
  invalidValue: type => {
    return type === 'date' ? exports.getValidationErrorMessage.dateInvalid() : exports.getValidationErrorMessage.timeInvalid();
  }
};
exports.DATE_PICKER_ERROR_MESSAGES = {
  pattern: exports.INPUT_VALIDATION_ERROR_MESSAGES.date.pattern,
  invalidDate: exports.INPUT_VALIDATION_ERROR_MESSAGES.date.invalidValue
};
/**
 * Calendar helper functions
 */
const getWeeksForMonth = date => {
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  // Get the first Sunday before or on the start of the month
  const start = new Date(startOfMonth);
  start.setDate(start.getDate() - start.getDay());
  // Get the last Saturday after or on the end of the month
  const end = new Date(endOfMonth);
  end.setDate(end.getDate() + (6 - end.getDay()));
  const weeks = [];
  const current = new Date(start);
  while (current <= end) {
    const week = [];
    for (let i = 0; i < exports.DAYS_IN_WEEK; i++) {
      week.push({
        date: new Date(current),
        isCurrentMonth: current.getMonth() === date.getMonth()
      });
      current.setDate(current.getDate() + 1);
    }
    weeks.push(week);
  }
  return weeks;
};
exports.getWeeksForMonth = getWeeksForMonth;
